module.exports = __webpack_public_path__ + "static/img/model-swiper1.78d188f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/model-swiper1.jpg
// module id = aaxa
// module chunks = 0